<div class="w-75">
  <h1 class="title">Uppdatera användare</h1>

  <h2>{{ anvandare.anvandarnamn }}</h2>
  <form [formGroup]="editAnvandareForm">
    <div class="form">
      <div>
        <label for="">Användartyp</label>
        <input type="text" class="form-control disabled-input" formControlName="anvandartyp" readonly />
      </div>
      <div>
        <label for="">Förnamn</label>
        <input type="text" class="form-control" formControlName="fornamn" />
      </div>
      <div>
        <label for="">Användarnamn</label>
        <input type="text" class="form-control disabled-input" formControlName="anvandarnamn" readonly />
      </div>
      <div>
        <label for="">Efternamn</label>
        <input type="text" class="form-control" formControlName="efternamn" />
      </div>
    </div>
    <app-button
      *ngIf="anvandare.anvandartyp === 'Extern' && canEditOrgs"
      icon="plus"
      text="Lägg till en organisationstillhörighet"
      [buttonStyle]="'secondary'"
      (click)="openAddAnvandareOrganisationDialog()"
    ></app-button>

    @if (anvandareOrganisationOptions.length > 1) {
      <app-banner
        text="Användaren har behörigheter på flera organisationer. Använd dropdown nedan för att se uppgifterna kopplade till respektive organisation."
        severity="red"
      ></app-banner>
    }
    <div class="organisations" formArrayName="anvandareOrganisationer">
      <div *ngIf="anvandare.anvandartyp === 'Intern' || anvandareOrganisationOptions.length === 1">
        <div>
          <label for="">Organisation</label>
          <input
            type="text"
            class="form-control disabled-input"
            [value]="anvandareOrganisationOptions[0].organisation"
            readonly
          />
        </div>
      </div>
      <div *ngIf="anvandare.anvandartyp === 'Extern' && anvandareOrganisationOptions.length > 1" class="change-org">
        <div>
          <label for="">Välj organisation</label>
          <div>
            <p-select
              [options]="anvandareOrganisationOptions"
              optionLabel="organisation"
              (onChange)="updateSelectedOrg($event.value)"
              [(ngModel)]="selectedAnvandareOrganisation"
              [ngModelOptions]="{ standalone: true }"
            ></p-select>
          </div>
        </div>
        <app-button
          *ngIf="anvandareOrganisationOptions.length > 1 && canEditOrgs"
          buttonStyle="tertiary"
          style="align-self: center"
          [danger]="true"
          icon="minus"
          text="Ta bort organisationstillhörighet"
          (click)="removeOrg()"
        ></app-button>
      </div>

      <div>
        @for (org of getAnvandareOrganisationer().controls; track org; let i = $index) {
          <div
            [formGroupName]="i"
            *ngIf="org.value.organisationId === selectedAnvandareOrganisation.organisationId"
            class="org-info"
          >
            <div>
              <div>
                <label>Titel i organisation</label>
                <input type="text" class="form-control disabled-input" [class.disabled-input]="disbleForExternAdminFlag" formControlName="titel" />
              </div>
              <div>
                <label>E-post</label>
                <input type="text" class="form-control" [class.disabled-input]="disbleForExternAdminFlag" formControlName="epost" />
                @if (org.get("epost")?.errors?.["required"]) {
                  <p class="text-danger">* E-post måste vara ifyllt</p>
                }
                @if (org.get("epost")?.errors?.["pattern"]) {
                  <p class="text-danger">* Ogiltigt e-post format</p>
                }
              </div>
              <div>
                <label>Mobilnummer</label>
                <input type="text" class="form-control" [class.disabled-input]="disbleForExternAdminFlag" formControlName="telefon" />
                @if (org.get("telefon")?.errors?.["required"]) {
                  <p class="text-danger">* Mobilnummer måste vara ifyllt</p>
                }
                @if (org.get("telefon")?.errors?.["pattern"]) {
                  <p class="text-danger">* Ogiltiga tecken</p>
                }
              </div>
            </div>
            <div class="roller">
              <div class="brodtext-medium-14 mb-4">Systemroller</div>
              <div *ngFor="let roll of selectedOrganisationRoles">
                <input
                  *ngIf="roll.show"
                  name="{{ roll.roll }}"
                  class="form-check-input"
                  [class.disabled-input]="disbleForExternAdminFlag"
                  type="checkbox"
                  [(ngModel)]="roll.checked"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label *ngIf="roll.show" class="form-check-label ms-2" for="">{{ getRoleLabel(roll.roll) }}</label>
              </div>
            </div>
          </div>
        }
        <div class="d-flex justify-content-between mt-4">
          <app-button text="Avbryt" buttonStyle="secondary" (click)="cancel()"></app-button>
          <app-button
            text="Spara"
            buttonStyle="primary"
            [disabled]="editAnvandareForm.invalid"
            [callback]="save"
          ></app-button>
        </div>
      </div>
    </div>
  </form>
</div>
